import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';
import { Col, Card, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import { destroy } from 'redux-form';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import {
  COURSES_SUCCESS,
  COURSES_FAILED,
  courseClearState as courseClearStateAction,
  getAsyncData as getAsyncDataAction,
  getCourse as getCourseAction,
} from '../../../../redux/actions/coursesAction';
import WizardFormOne from './WizardFormOne';
import WizardFormTwo from './WizardFormTwo';
import WizardFormThree from './WizardFormThree';
import WizardFormFour from './WizardFormFour';
import { FullWideNotification } from '../../../../shared/components/Notification';

class WizardForm extends PureComponent {
  static propTypes = {
    initialValues: PropTypes.objectOf(PropTypes.any).isRequired,
    history: PropTypes.objectOf(PropTypes.any).isRequired,
    asyncData: PropTypes.objectOf(PropTypes.any).isRequired,
    asyncStatus: PropTypes.string.isRequired,
    submitStatus: PropTypes.string.isRequired,
    loadStatus: PropTypes.string.isRequired,
    showNotification: PropTypes.func.isRequired,
    getAsyncData: PropTypes.func.isRequired,
    courseClearState: PropTypes.func.isRequired,
    getCourse: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.state = {
      page: 1,
    };
  }

  componentDidMount() {
    const {
      // eslint-disable-next-line react/prop-types
      getAsyncData,
      getCourse,
      // eslint-disable-next-line react/prop-types
      match,
      // eslint-disable-next-line react/prop-types
      reinitializeReduxForm,
    } = this.props;
    // eslint-disable-next-line react/prop-types
    const { courseId } = match.params;

    reinitializeReduxForm();

    getAsyncData();
    getCourse(courseId);
  }

  componentWillReceiveProps(nextProps) {
    const { submitStatus, loadStatus, history } = nextProps;

    if (loadStatus === COURSES_FAILED) {
      history.push('/404');
    }

    if (submitStatus === COURSES_SUCCESS) {
      history.push('/courses');
    } else if (submitStatus === COURSES_FAILED) {
      this.show('danger', 'Произошла непредвиденная ошибка. Обратитесь к разработчикам.');
    }
  }

  componentWillUnmount() {
    const { courseClearState } = this.props;
    courseClearState();
  }

  show = (color, message) => {
    const { showNotification } = this.props;
    return showNotification({
      notification: <FullWideNotification color={color} message={message} />,
      position: 'full',
    });
  };

  nextPage = () => {
    this.setState((prevState) => ({ page: prevState.page + 1 }));
  };

  previousPage = () => {
    this.setState((prevState) => ({ page: prevState.page - 1 }));
  };

  render() {
    const { asyncData, asyncStatus, loadStatus, showNotification, initialValues } = this.props;
    const { page } = this.state;

    return (
      <Row>
        <Col md={12} lg={12}>
          <Card>
            <div className="wizard">
              <div className="wizard__steps">
                <div className={`wizard__step${page === 1 ? ' wizard__step--active' : ''}`}>
                  <p>Шаг 1</p>
                </div>
                <div className={`wizard__step${page === 2 ? ' wizard__step--active' : ''}`}>
                  <p>Шаг 2</p>
                </div>
                <div className={`wizard__step${page === 3 ? ' wizard__step--active' : ''}`}>
                  <p>Шаг 3</p>
                </div>
                <div className={`wizard__step${page === 4 ? ' wizard__step--active' : ''}`}>
                  <p>Шаг 4</p>
                </div>
              </div>
              {asyncStatus === COURSES_SUCCESS && loadStatus === COURSES_SUCCESS && (
                <div className="wizard__form-wrapper">
                  {page === 1 && (
                    <WizardFormOne onSubmit={this.nextPage} asyncData={asyncData} initialValues={initialValues} />
                  )}
                  {page === 2 && (
                    <WizardFormTwo previousPage={this.previousPage} onSubmit={this.nextPage} asyncData={asyncData} />
                  )}
                  {page === 3 && (
                    <WizardFormThree
                      previousPage={this.previousPage}
                      onSubmit={this.nextPage}
                      showNotification={showNotification}
                    />
                  )}
                  {page === 4 && <WizardFormFour previousPage={this.previousPage} />}
                </div>
              )}
            </div>
          </Card>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({
  initialValues: state.courses.active,
  asyncData: state.courses.asyncData,
  asyncStatus: state.courses.asyncStatus,
  submitStatus: state.courses.submitStatus,
  loadStatus: state.courses.loadActiveStatus,
});

const mapDispatchToProps = (dispatch) => ({
  getCourse: (courseId) => dispatch(getCourseAction(courseId)),
  getAsyncData: () => dispatch(getAsyncDataAction()),
  courseClearState: () => dispatch(courseClearStateAction()),
  reinitializeReduxForm: () => dispatch(destroy('courses_edit_form')),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(withRouter(WizardForm)));
